module.exports = __webpack_public_path__ + "static/media/Leccion-8-20-Los-Desafios-de-la-Vida.f67deab4.pdf";